import React from 'react';

// Hooks
import { useOnboardingState } from 'Shared/utils/hooks/use-onboarding-state';

// Components
import { WpCard, WpCardBody } from 'Wpds/components/card';
import { WpButton } from 'Wpds/components/button';
import OnboardingSlackTitle from './OnboardingSlackTitle';

// Styles
import './OnboardingSlackKeepUsing.scss';

const OnboardingSlackKeepUsing = () => {
  const { handleAdvanceBackOnboardingState, handleAdvanceOnboardingState, isAdvancingForward } = useOnboardingState();

  const baseClassName = 'OnboardingSlackKeepUsing';

  return (
    <div className={baseClassName}>
      <OnboardingSlackTitle onBack={handleAdvanceBackOnboardingState} title="Keep using AgendaAI" />
      <div>
        <WpCard className={`${baseClassName}__card`}>
          <WpCardBody padding={0}>
            <div className={`${baseClassName}__card__img-wrapper`}>
              <img
                className={`${baseClassName}__card__img-wrapper__img`}
                src="https://piprodperformassets.blob.core.windows.net/assets/charma_hr_magic_blue.png"
                alt=""
              />
            </div>
          </WpCardBody>
          <WpCardBody className={`${baseClassName}__card__main`}>
            <h4>Customize in PI Perform</h4>
            <p className={`${baseClassName}__card__main__description`}>
              Customize AgendaAI’s responses and collaborate with your teammates in real time. Free to sign up — no
              credit card needed!
            </p>
            <WpButton block size="lg" onClick={handleAdvanceOnboardingState} loading={isAdvancingForward}>
              Let&apos;s go
            </WpButton>
          </WpCardBody>
        </WpCard>
      </div>
    </div>
  );
};

export default OnboardingSlackKeepUsing;
